import * as Yup from 'yup';
import React, { useState, forwardRef } from 'react';
import { Icon } from '@iconify/react';
import { useFormik, Form, FormikProvider } from 'formik';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
import { useNavigate } from 'react-router-dom';
// material

import {
  Stack,
  TextField,
  IconButton,
  Slide,
  InputAdornment,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContentText,
  DialogContent
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { AddUserData } from '../../../network/User';

/* eslint-disable */
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
/* eslint-enable */

export default function RegisterForm() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [errorData, setErrorData] = useState({
    visible: false,
    message: ''
  });

  const RegisterSchema = Yup.object().shape({
    name: Yup.string().min(2, 'Too Short!').max(50, 'Too Long!').required('First name required'),
    email: Yup.string().email('Email must be a valid email address').required('Email is required'),
    password: Yup.string().required('Password is required')
  });

  const formik = useFormik({
    initialValues: {
      name: '',
      email: '',
      phoneNo: '',
      password: ''
    },
    validationSchema: RegisterSchema,
    onSubmit: (values, { resetForm }) => {
      formik.isSubmitting = true;
      const payload = {
        name: values.name,
        email: values.email,
        phone: values.phoneNo,
        role: 'manager',
        password: values.password
      };
      register(payload);
    }
  });

  const handleAlertDialogClose = () => {
    setErrorData({ ...errorData, visible: false, message: '' });
  };
  const handleDialogSuccessAction = () => {
    navigate('/login', { replace: true });
  };

  const { errors, touched, handleSubmit, isSubmitting, getFieldProps } = formik;

  const register = async (payload) => {
    alert('');
    try {
      const res = await AddUserData(payload);
      if (res) {
        setErrorData({
          ...errorData,
          visible: true,
          message: 'Your account has been created,please login with your credentials.'
        });
      }
    } catch (err) {
      formik.setSubmitting(false);

      if (err != null) {
        if (err?.response?.data !== null)
          if (err?.response?.data?.error !== null) {
            setErrorData({
              ...errorData,
              visible: true,
              message: err?.response?.data?.error?.message,
              title: err?.response?.data?.error?.title
            });
            return;
          }
      }
      setErrorData({
        ...errorData,
        visible: true,
        message: 'Oops something went wrong, please try again !'
      });
    }
  };

  return (
    <div>
      <FormikProvider value={formik}>
        <Form data-testid="register-form" autoComplete="off" noValidate onSubmit={handleSubmit}>
          <Stack spacing={3}>
            <TextField
              fullWidth
              label="Name"
              {...getFieldProps('name')}
              error={Boolean(touched.name && errors.name)}
              helperText={touched.name && errors.name}
            />

            <TextField
              fullWidth
              autoComplete="username"
              type="email"
              label="Email address"
              {...getFieldProps('email')}
              error={Boolean(touched.email && errors.email)}
              helperText={touched.email && errors.email}
            />

            <TextField
              fullWidth
              label="Phone no"
              type="number"
              {...getFieldProps('phoneNo')}
              error={Boolean(touched.phoneNo && errors.phoneNo)}
              helperText={touched.phoneNo && errors.phoneNo}
            />

            <TextField
              fullWidth
              autoComplete="current-password"
              type={showPassword ? 'text' : 'password'}
              label="Password"
              {...getFieldProps('password')}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton edge="end" onClick={() => setShowPassword((prev) => !prev)}>
                      <Icon icon={showPassword ? eyeFill : eyeOffFill} />
                    </IconButton>
                  </InputAdornment>
                )
              }}
              error={Boolean(touched.password && errors.password)}
              helperText={touched.password && errors.password}
            />

            <LoadingButton
              fullWidth
              size="large"
              type="submit"
              variant="contained"
              loading={isSubmitting}
            >
              Register
            </LoadingButton>
          </Stack>
        </Form>
      </FormikProvider>

      <Dialog
        open={errorData?.visible}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => handleAlertDialogClose()}
        aria-describedby="iot_res_alert-dialog-slide-description"
      >
        <DialogTitle>{errorData?.title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="aiot_res_alert-dialog-slide-description">
            {errorData?.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleDialogSuccessAction()}>OK</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
